/**
 * RelatedItems component.
 * @module components/theme/RelatedItems/RelatedItems
 */

import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { defineMessages, injectIntl } from 'react-intl';
import { Container } from 'semantic-ui-react';

const messages = defineMessages({
  relatedContent: {
    id: 'Related Content',
    defaultMessage: 'Related Content',
  },
});

/**
 * Related Items component.
 * @function RelatedItems
 * @param {array} tags Array of related items.
 * @returns {string} Markup of the component.
 */

const RelatedItems = ({ content }) => {
  const intl = useIntl();

  if (!content?.relatedItems?.length) {
    return null;
  }

  return (
    <Container>
      <h2 className="section-subtitle">
        <span>{intl.formatMessage(messages.relatedContent)}</span>
      </h2>
      <div className="ui list">
        {content.relatedItems.map((relatedItem) =>
          relatedItem ? (
            <div className="item mb-5" key={relatedItem['@id']}>
              <div className="content">
                <UniversalLink className="header" item={relatedItem}>
                  <div className="text-up-01 text-md-up-02 text-weight-semi-bold text-blue-warm-vivid-80">
                    {relatedItem['title']}
                  </div>
                </UniversalLink>
              </div>
            </div>
          ) : null,
        )}
      </div>
    </Container>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
RelatedItems.propTypes = {
  content: PropTypes.shape({
    relatedItems: PropTypes.arrayOf(
      PropTypes.shape({
        '@id': PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
      }),
    ),
  }),
};

export default injectIntl(RelatedItems);
